export default __webpack_public_path__ + "static/media/shape-rect-full.30fb4621.svg";